import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { stringify as toQS } from 'querystring';
import messages from '@/locals/en-US.json';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Ensures a phone number has the + prefix
 * @param phoneNumber - The phone number to format
 * @returns The phone number with + prefix
 */
export function ensurePhonePrefix(phoneNumber: string | null | undefined): string {
  if (!phoneNumber) return "";
  
  return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
}

export const getPath = (path: string, params?: any) => {
  if (!params) {
    return path;
  }

  return `${path}?${toQS(params)}`;
}

export const getMessage = (key: string): string | undefined => {
  const keys = key.split('.');
  let result: any = messages;

  for (const k of keys) {
    if (result[k] !== undefined) {
      result = result[k];
    } else {
      return undefined;
    }
  }

  return result;
}

export const generateRandomString = (length = 32) => {
  if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
  } else {
    // fallback for environments without crypto
    return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }
};